import axios from 'axios'

const realEstateService = {}

realEstateService.getRealEstateAdvisers = async () => {
  const response = await axios.get('https://admintest.abadfaciolince.com/api/admin/asesores')
  return response.data.asesores
}

realEstateService.getNeighborhoods = async (sector) => {
  const response = await axios.get('https://admintest.abadfaciolince.com/api/barrios?sector=' + sector.id)
  return response.data
}

realEstateService.getOwners = async () => {
  const response = await axios.get('https://admintest.abadfaciolince.com/api/admin/propietarios')
  return response.data.propietarios
}

realEstateService.createAdviser = async data => {
  try {
    const { email, cedula, nombres, fijo, celular, fechaNacimiento, nombres2, fijo2, celular2, comentarios } = data

    const request = {
      data: {
        email,
        cedula,
        nombres,
        fijo,
        celular,
        fechaNacimiento,
        nombres2,
        fijo2,
        celular2,
        comentarios
      },
      method: 'POST',
      url: 'https://admintest.abadfaciolince.com/api/admins/asesors/creates'
    }

    const response = await axios(request)
    return response.data
  } catch (e) {
    throw new Error(e.response.data.message)
  }
}

realEstateService.createOwner = async data => {
  try {
    const { email, cedula, nombres, fijo, celular, fechaNacimiento, nombres2, fijo2, celular2, comentarios } = data

    const request = {
      data: {
        email,
        cedula,
        nombres,
        fijo,
        celular,
        fechaNacimiento,
        nombres2,
        fijo2,
        celular2,
        comentarios
      },
      method: 'POST',
      url: 'https://admin.abadfaciolince.com/api/admins/propietarios/creates'
    }

    const response = await axios(request)
    return response.data
  } catch (e) {
    throw new Error(e.response.data.message)
  }
}

realEstateService.editAdviser = async (data) => {
  try {
    const { id, email, cedula, nombres, fijo, celular, fechaNacimiento, nombres2, fijo2, celular2, comentarios } = data

    const request = {
      data: {
        id,
        email,
        cedula,
        nombres,
        fijo,
        celular,
        fechaNacimiento,
        nombres2,
        fijo2,
        celular2,
        comentarios
      },
      method: 'POST',
      url: 'https://admintest.abadfaciolince.com/api/admins/asesors/edits'
    }

    const response = await axios(request)
    return response.data
  } catch (e) {
    throw new Error(e.response.data.message)
  }
}

realEstateService.editOwner = async (data) => {
  try {
    const { id, email, cedula, nombres, fijo, celular, fechaNacimiento, nombres2, fijo2, celular2, comentarios } = data

    const request = {
      data: {
        id,
        email,
        cedula,
        nombres,
        fijo,
        celular,
        fechaNacimiento,
        nombres2,
        fijo2,
        celular2,
        comentarios
      },
      method: 'POST',
      url: 'https://admin.abadfaciolince.com/api/admins/propietarios/edits'
    }

    const response = await axios(request)
    return response.data
  } catch (e) {
    throw new Error(e.response.data.message)
  }
}

realEstateService.getProperties = async data => {
  const { alcobas, barrio, codigo, propietario, proposito, propositoValor, sector, tipoPropiedad, urbanizacion, zona, options } = data

  const request = {
    method: 'GET',
    params: {
      alcobas,
      barrio,
      codigo,
      limit: options.itemsPerPage,
      propietario,
      proposito,
      propositoValor,
      sector,
      tipoPropiedad,
      urbanizacion,
      zona,
      offset: options.itemsPerPage * (options.page - 1)
    },
    url: 'https://admintest.abadfaciolince.com/api/propiedades/private'
  }

  const response = await axios(request)
  return response.data
}

realEstateService.getPropertyDetails = async (code) => {
  const response = await axios.get(`https://admintest.abadfaciolince.com/api/admin/propiedad?codigo=${code}`)
  return response.data
}

realEstateService.getSectors = async (zone) => {
  const response = await axios.get('https://admintest.abadfaciolince.com/api/sectores?zona=' + zone.id)
  return response.data
}

realEstateService.getUnidades = async unidad => {
  const response = await axios.get('https://admintest.abadfaciolince.com/api/admin/urbanizaciones?urbanizacion=' + unidad)
  return response.data
}

realEstateService.getZones = async () => {
  const response = await axios.get('https://admintest.abadfaciolince.com/api/zonas')
  return response.data
}

export default realEstateService
